import { Component, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { MAT_DIALOG_DATA} from '@angular/material/dialog';
import { Observable, catchError, debounceTime, distinctUntilChanged, map, of, switchMap } from 'rxjs';
import { SearchSelectService } from '../search-select.service';
import { ItemType } from '../search-select.component';

@Component({
  selector: 'app-mobile-selection',
  templateUrl: './mobile-selection.component.html',
  styleUrls: ['./mobile-selection.component.scss'],
})
export class MobileSelectionComponent {
  items:ItemType[]|null = null;
  inputName:string | null | undefined = ''
  type:any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {isMobile: boolean, type: 'city'|'school', selectedItem: ItemType|null, layer:number},
    private formBuilder: UntypedFormBuilder,
    private searchSelect: SearchSelectService,
  ){}
  formGroup = this.formBuilder.group({
    control: new UntypedFormControl(),
  })
  ngOnInit(): void { 
    this.getItemObs().subscribe()
    this.type = this.data.type
    if(this.data.selectedItem)
      this.formGroup.controls['control'].setValue(this.data.selectedItem.name)
  }
  getInputValue():Observable<string>{
    return this.formGroup.controls['control'].valueChanges.pipe(
      distinctUntilChanged(),
      debounceTime(300),
    )
  }
  emitWhenBackCloseArrowDialogCall(){
    console.log(this.data.selectedItem)
    if(this.data.selectedItem && this.data.selectedItem.name!='') return this.data.selectedItem;
    else return this.inputName && this.inputName!='' ? this.inputName : null
  }
  getItemObs():Observable<any>{
  return this.getInputValue().pipe(
      switchMap((inputValue:string|null|undefined)=>{
        return this.searchSelect.getItems(this.data.type, inputValue).pipe(
          map((response:any)=>response.results),
          map(((results:any[])=>{
            this.inputName = inputValue;
            return this.items = results;
          })),
          catchError(err => {
            this.items = null; 
            return of(null); 
          })
        )
      }),
    )
  }
  canAdd():boolean{
    return this.items?.findIndex(i=>i.name==this.inputName) == -1 && this.data.type == 'school'
  }
}
